import { useEffect, useRef, useState } from "react";
import { motion, useInView, useReducedMotion, animate } from "framer-motion";

const EASE = [0.2, 0.7, 0.2, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </Comp>
  );
};

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0.2, onLoad = true }) => {
  const reduce = useReducedMotion();
  const line = {
    hidden: { y: "110%" },
    show: (i) => ({ y: "0%", transition: { duration: 1.1, delay: delay + i * 0.11, ease: [0.7, 0, 0.2, 1] } }),
  };
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <motion.span className={`block ${className}`} initial={reduce ? false : "hidden"} {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span className={`block ${lineClass}`} variants={line} custom={i}>{l}</motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Counter = ({ value, testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });
  const reduce = useReducedMotion();
  const [n, setN] = useState(reduce ? value : 0);
  useEffect(() => {
    if (!inView || reduce) return undefined;
    const c = animate(0, value, { duration: 2.2, ease: [0.16, 1, 0.3, 1], onUpdate: (v) => setN(Math.round(v)) });
    return () => c.stop();
  }, [inView, reduce, value]);
  return <span ref={ref} data-testid={testId}>{n.toLocaleString("it-IT")}</span>;
};

export const CropFrame = ({ children, className = "", color = "text-[color:var(--ngp-ink)]" }) => (
  <div className={`crop-marks ${color} ${className}`}>
    <span className="cm tl" /><span className="cm tr" /><span className="cm bl" /><span className="cm br" />
    {children}
  </div>
);
